import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, getAuth, onAuthStateChanged, User } from 'firebase/auth';

/** Hergebruik dezelfde cached user vanuit auth.guard.ts */
let cachedUser: User | null | undefined = undefined;
let auth: Auth | null = null;
let listenerSetup = false;

function getAuthLazy(): Auth {
  if (!auth) auth = getAuth();
  return auth;
}

export const loginGuard = async () => {
  const router = inject(Router);
  const authInstance = getAuthLazy();
  if (!listenerSetup) {
    listenerSetup = true;
    onAuthStateChanged(authInstance, (user) => {
      cachedUser = user;
    });
  }

  if (cachedUser !== undefined) {
    return !cachedUser ? true : router.parseUrl('/webshop');
  }

  return new Promise<any>((resolve) => {
    const unsubscribe = onAuthStateChanged(authInstance, (user) => {
      unsubscribe();
      cachedUser = user;
      resolve(!user ? true : router.parseUrl('/webshop'));
    });
  });
};
